import { render, staticRenderFns } from "./app-check-update.vue?vue&type=template&id=cf5e7250&scoped=true"
import script from "./app-check-update.vue?vue&type=script&lang=js"
export * from "./app-check-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5e7250",
  null
  
)

export default component.exports